import PropTypes from 'prop-types'
import React from 'react'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import AusbildungsplanKachel from '#components/o/Uebersicht/AusbildungsplanKachel'
import PraxisaufgabenKachel from '#components/o/Uebersicht/PraxisaufgabenKachel'
import AusbildungsnachweiseKachel from '#components/o/Uebersicht/AusbildungsnachweiseKachel'
import useAusbilderDashboardData from '#hooks/store/useAusbilderDashboardData'
import Loading from '#components/a/Loading'
import Greeting from '#components/a/Greeting'
import {usePermissions} from '#hooks/usePermissions'

export function Uebersicht({userInfo}) {
  const {firstname} = userInfo
  const permissions = usePermissions()
  const filterAbteilungen = permissions.meineAzubis.canFilterAzubisByMyAbteilungen
  const {isLoading, ausbildungsnachweiseModel, ausbildungsplanModel, praxisaufgabenModel} = useAusbilderDashboardData()

  function DashboardContent() {
    return (
      <div className="box-container">
        <div className="col-flex">
          {ausbildungsplanModel && (
            <AusbildungsplanKachel ausbildungsplanModel={ausbildungsplanModel} showAllItems={false} />
          )}
          <PraxisaufgabenKachel praxisaufgabenModel={praxisaufgabenModel} showAllItems={false} />
        </div>
        <div className="col-flex">
          <AusbildungsnachweiseKachel
            ausbildungsnachweiseModel={ausbildungsnachweiseModel}
            showAllItems={false}
            filterAbteilungen={filterAbteilungen}
          />
        </div>
      </div>
    )
  }

  return (
    <div className="uebersicht meineAusbildung">
      <div className="header-wrapper">
        <Greeting firstName={firstname} />
      </div>
      {isLoading ? <Loading /> : <DashboardContent />}
    </div>
  )
}

Uebersicht.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
  }).isRequired,
}

export default UserInfoHOC(Uebersicht)
